import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { IonApp, setupIonicReact } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';
import * as Sentry from '@sentry/react';

import * as packageJson from '../package.json';
import App from './App.tsx';
import './index.scss';
import { ServiceError } from './services/errors.ts';

const isProd = 'production' === import.meta.env.MODE;
const prodOrDev = ['production', 'dev'].includes(import.meta.env.MODE);

Sentry.init({
  dsn: 'https://38795c02fb8e468290e7a22bade0ec12@o468549.ingest.us.sentry.io/4507972746674176',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  maxBreadcrumbs: 50,
  release: packageJson.version,
  environment: import.meta.env.VITE_NODE_ENV,
  debug: !prodOrDev,
  // Tracing
  tracesSampleRate: prodOrDev ? 1.0 : 0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: isProd ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: prodOrDev ? 1.0 : 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeSend(event, hint) {
    const exceptionValues =
      event.exception?.values && event.exception.values[0];
    // If we threw the error ignore
    if (
      hint.originalException instanceof ServiceError &&
      exceptionValues?.mechanism?.handled
    )
      return null;

    // Otherwise, send the event to Sentry
    return event;
  }
});

setupIonicReact();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <IonApp>
        <App />
      </IonApp>
    </BrowserRouter>
  </React.StrictMode>
);
